import { t } from '@shared/helpers/translation';
import { AgeRangeDefinitions, PassengerType } from '@/api/Checkout/checkout.interfaces';
import { ProductType, Room } from '@/api/Cart/cart.interfaces';
import { getAgeConfigByProduct } from '@/helpers/dobValidation';

export function getPersonsFormattedText(
    adults: number,
    children: number,
    infants: number = 0
): string {
    const items = [] as string[];

    const labelAdults =
        adults > 0
            ? `${adults} ${t({
                  key: 'shared.adult',
                  keyPlural: 'shared.adults',
                  count: adults,
              })}`
            : '';

    const labelChildren =
        children > 0
            ? `${children} ${t({
                  key: 'shared.child',
                  keyPlural: 'shared.children',
                  count: children,
              })}`
            : '';

    const labelInfants =
        infants > 0
            ? `${infants} ${t({
                  key: 'shared.infant',
                  keyPlural: 'shared.infants',
                  count: infants,
              })}`
            : '';

    if (adults) items.push(labelAdults);
    if (children) items.push(labelChildren);
    if (labelInfants) items.push(labelInfants);
    return items.join(', ');
}

export const getPaxSubHeader = (
    ageDefinitions: AgeRangeDefinitions,
    productType: ProductType,
    productAge?: number | null
) => {
    const config = getAgeConfigByProduct(ageDefinitions, productType, productAge);
    switch (config.Type) {
        case PassengerType.Infant:
        case PassengerType.Child:
            return `${t({ key: 'shared.child' })}, ${config.Min}-${config.Max} ${t({
                key: 'shared.years_old',
            })}`;

        default:
            return t({ key: 'shared.adult' });
    }
};

export function getRoomGuests({ PaxDescription }: Room) {
    const guests = {
        adults: PaxDescription.filter((p) => p.IsAdult).length,
        children: PaxDescription.filter((p) => !p.IsAdult).length,
    };

    const adults =
        guests.adults > 0
            ? `${guests.adults} ${t({
                  key: 'shared.adult',
                  keyPlural: 'shared.adults',
                  count: guests.adults,
              })}`
            : '';

    const children =
        guests.children > 0
            ? `, ${guests.children} ${t({
                  key: 'shared.child',
                  keyPlural: 'shared.children',
                  count: guests.children,
              })}`
            : '';

    return `${adults}${children}`;
}
